export const fileType = {
  excel: 'Excel',
  csv: 'CSV'
};
